import { Client } from 'boardgame.io/react';
import { TurnOrder, Stage, INVALID_MOVE } from 'boardgame.io/core';
import { Local } from 'boardgame.io/multiplayer';
import React from 'react';
import TicTacToeBoard from './TicTacToeBoard';
import CardChessBoard from './CardChessBoard';
import { Step, MCTSBot } from 'boardgame.io/ai';
import { BattleCardGameRule } from './GameRule';

const TicTacToeClient = Client({
  game: BattleCardGameRule,
  board: CardChessBoard,
  // multiplayer: Local({bots: {'1': MCTSBot}}),
});


const App = () => (
  <div>
    <TicTacToeClient />
    {/* <TicTacToeClient playerID="0"/>*/}
     {/*<TicTacToeClient playerID="1"/>*/}
  </div>
);

export default App;
